import React from 'react'
import { use } from 'xadmin'
import { C, lazy } from 'xadmin-ui';
import moment from 'moment'
import { InputNumber, Input, Typography, Switch, DatePicker } from 'antd'

const VariableTree = C.lazy('VariableTree')

const JEditor = ({ value, onChange }) => {
  return (
    <div style={{ border: '1px solid #d9d9d9', borderRadius: 2, padding: '10px' }}>
      <VariableTree data={value} editable={true} onChange={onChange}></VariableTree>
    </div>
  )
}

const VEditor = props => {
  const { input } = props
  const { form } = use('form')
  const [type, setType] = React.useState(null)
  const cache = React.useRef(null)

  form.useField('type', state => {
    if (!cache.current && state.value || (state.value && cache.current != state.value)) {
      cache.current = state.value
      setType(state.value)
      // 重新选择类型后清空原有值
      onChange && onChange(state.value == 'boolean' ? false : null)
    }
  })

  const value = input.value?.value
  const onChange = value => { input.onChange({ value }) }

  if (type == 'object') {
    const defaultValue = value && _.isPlainObject(value) ? value : {}
    return <JEditor onChange={onChange} value={defaultValue} />
  } else if (type == 'array') {
    const defaultValue = value && _.isArray(value) ? value : []
    return <JEditor onChange={onChange} value={defaultValue} />
  } else if (type == 'number') {
    const defaultValue = value || _.isNumber(value) ? value : null
    return <InputNumber {...input} onChange={onChange} value={defaultValue} />
  } else if (type == 'string') {
    const defaultValue = value && (_.isString(value) || _.isNumber(value)) ? value : null
    return <Input {...input} onChange={e => onChange(e.target.value)} value={defaultValue} />
  } else if (type == 'boolean') {
    const defaultValue = value ? Boolean(value) : false
    return <Switch {...input} onChange={onChange} checked={defaultValue} />
  } else if (type == 'date') {
    const defaultValue = value ? moment(value) : null
    return <DatePicker {...input} onChange={v => onChange(v ? v.format('YYYY-MM-DD') : v)} format="YYYY-MM-DD" value={defaultValue} />
  } else if (_.isNil(type)) {
    return <Typography.Text type="secondary">请选择数据类型</Typography.Text>
  } else {
    return <Typography.Text type="danger">无效的数据类型</Typography.Text>
  }
}

export default VEditor